import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { screens } from '../screens';
import { components } from '../components';
import { TabNavigator } from './TabNavigator';
import { Home } from '../screens/tabs/Home';
import { Home2 } from '../screens/tabs/Home2';
import ProtectedRoute from '../customHook/ProtectedRoute';

const stack = createBrowserRouter([
  {
    path: '/',
    element: <screens.Onboarding />,
  },
  {
    path: '/onbording1',
    element: <screens.Onboarding1 />,
  },
  {
    path: '/onbording2',
    element: <screens.Onboarding2 />,
  },
  {
    path: '/onbording3',
    element: <screens.Onboarding3 />,
  },
  {
    path: '/onbording4',
    element: <screens.Onboarding4 />,
  },
  {
    path: '/onbording5',
    element: <screens.Onboarding5 />,
  },
  {
    path: '/onbording6',
    element: (
      <ProtectedRoute>
        <screens.Onboarding6 />
      </ProtectedRoute>
    ),
    // element: <screens.Onboarding6 />,
  },
  {
    path: '/onbording7',
    element: (
      <ProtectedRoute>
        <screens.Onboarding7 />
      </ProtectedRoute>
    ),
  },
  {
    path: '/notification',
    element: (
      <ProtectedRoute>
        <screens.NotificationPage1 />
      </ProtectedRoute>
    ),
    // element: <screens.NotificationPage1 />,
  },
  {
    path: '/sign-in',
    element: <screens.SignIn />,
  },
  {
    path: '/profile/edit',
    element: (
      <ProtectedRoute>
        <screens.ProfileEdit />
      </ProtectedRoute>
    ),
    // element: <screens.ProfileEdit />,

  },
  {
    path: '/forgot-password',
    element: <screens.ForgotPassword />,
  },
  {
    path: '/profile/privacy-policy',

    element: <screens.PrivacyPolicy />,
  },
  {
    path: '/terms-conditions',
    element: <screens.TermsAndConditions />,
  },
  {
    path: '/loan-options',
    element: <screens.LoanOptions />,
  },
  {
    path: '/our-services',
    element: <screens.OurServices />,
  },
  {
    path: '/contact-us',
    element: <screens.ContactUs />,
  },
  {
    path: '/profile/payrent',
    element: <screens.MyWishlist />,
  },
  {
    path: '/sign-up',
    element: <screens.SignUp />,
  },
  {
    path: '/verify-your-phone-number',
    element: <screens.VerifyYourPhoneNumber />,
  },
  {
    path: '/choose-payment-method',
    element: <screens.ChoosePaymentMethod />,
  },
  {
    path: '/course-details',
    element: (
      <ProtectedRoute>
        <screens.CourseDetails />
      </ProtectedRoute>
    ),
    // element: <screens.CourseDetails />,
  },
  {
    path: '/room-type',
    element: <screens.RoomDetails />,
  },
  {
    path: '/confirmation-code',
    element: <screens.ConfirmationCode />,
  },
  {
    path: '/profile/help-and-support',
    element: <screens.HelpAndSupport />,

  },
  {
    path: '/help-center',
    element: <screens.HelpCenter />,
  },
  {
    path: '/new-password',
    element: <screens.NewPassword />,
  },
  {
    path: '/forgot-password-sent-email',
    element: <screens.ForgotPasswordSentEmail />,
  },
  {
    path: '/booking-success',
    element: <screens.BookingSuccess />,
  },
  {
    path: '/profile/edit',
    element: <screens.ProfileEdit />,
  },
  {
    path: '/profile/my-coupons',
    element: <screens.MyCoupons />,
  },
  {
    path: '/account-created',
    element: <screens.SignUpAccountCreated />,
  },
  {
    path: '/category-grid',
    element: <screens.CategoryGrid />,
  },
  {
    path: '/my-booking',
    element: <screens.ListDetails />,
  },
  {
    path: '/shortlisted',
    element: <screens.Shortlisted />,
  },
  {
    path: '/dashboard',
    element: <screens.Dashboard />,
  },
  {
    path: '/leave-a-review',
    element: <screens.LeaveAReview />,
  },
  {
    path: '/add-a-new-card',
    element: <screens.AddANewCard />,
  },
  {
    path: ' ',
    element: <screens.CourseCompletedCertificate />,
  },
  {
    path: '/checkout',
    element: <screens.Checkout />,
  },
  {
    path: '/filter',
    element: <screens.Filter />,
  },
  {
    path: '/profile/my-wallet',
    element: <screens.MyWallet />,
  },
  {
    path: '/course-completed',
    element: <screens.CourseCompleted />,
  },
  {
    path: '/category-list',
    element: (
      <ProtectedRoute>
        <screens.CategoryList />
      </ProtectedRoute>
    ),
    // element: <screens.CategoryList />,
  },
  {
    path: '/aminity-list',
    element: <screens.AminitiesList />,
  },
  {
    path: '/payment-failed',
    element: <screens.PaymentFailed />,
  },
  // {
  //   path: '/tab-navigator',
  //   element: <TabNavigator />,
  // },

  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/serach-result',
    element: <Home2 />,
  },
]);

export const StackNavigator: React.FC = () => {
  return <RouterProvider router={stack}
    future={{
      v7_startTransition: true,
      // v7_relativeSplatPath: true,
    }}
  />;
};







// Without Protect Route
// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { RouterProvider, createBrowserRouter } from 'react-router-dom';

// import { screens } from '../screens';
// import { components } from '../components';
// import { TabNavigator } from './TabNavigator';
// import { Home } from '../screens/tabs/Home';
// import { Home2 } from '../screens/tabs/Home2';
// import ProtectedRoute from '../customHook/ProtectedRoute';

// const stack = createBrowserRouter([
//   {
//     path: '/',
//     element: <screens.Onboarding />,
//   },
//   {
//     path: '/onbording1',
//     element: <screens.Onboarding1 />,
//   },
//   {
//     path: '/onbording2',
//     element: <screens.Onboarding2 />,
//   },
//   {
//     path: '/onbording3',
//     element: <screens.Onboarding3 />,
//   },
//   {
//     path: '/onbording4',
//     element: <screens.Onboarding4 />,
//   },
//   {
//     path: '/onbording5',
//     element: <screens.Onboarding5 />,
//   },
//   {
//     path: '/onbording6',
//     element: <screens.Onboarding6 />,
//   },
//   {
//     path: '/onbording7',

//     element: <screens.Onboarding7 />,
//   },
//   {
//     path: '/notification',
//     element: <screens.NotificationPage1 />,
//   },
//   {
//     path: '/sign-in',
//     element: <screens.SignIn />,
//   },
//   {
//     path: '/profile/edit',
//     element: <screens.ProfileEdit />,
//   },
//   {
//     path: '/forgot-password',
//     element: <screens.ForgotPassword />,
//   },
//   {
//     path: '/profile/privacy-policy',
//     element: <screens.PrivacyPolicy />,
//   },

//   {
//     path: '/contact-us',
//     element: <screens.ContactUs />,
//   },
//   {
//     path: '/profile/payrent',
//     element: <screens.MyWishlist />,
//   },
//   {
//     path: '/sign-up',
//     element: <screens.SignUp />,
//   },
//   {
//     path: '/verify-your-phone-number',
//     element: <screens.VerifyYourPhoneNumber />,
//   },
//   {
//     path: '/choose-payment-method',
//     element: <screens.ChoosePaymentMethod />,
//   },
//   {
//     path: '/course-details',
//     element: (
//       <ProtectedRoute>
//         <screens.CourseDetails />
//       </ProtectedRoute>
//     ),
//     // element: <screens.CourseDetails />,
//   },
//   {
//     path: '/room-type',
//     element: <screens.RoomDetails />,
//   },
//   {
//     path: '/confirmation-code',
//     element: <screens.ConfirmationCode />,
//   },
//   {
//     path: '/profile/help-and-support',
//     element: <screens.HelpAndSupport />,
//   },
//   {
//     path: '/new-password',
//     element: <screens.NewPassword />,
//   },
//   {
//     path: '/forgot-password-sent-email',
//     element: <screens.ForgotPasswordSentEmail />,
//   },
//   {
//     path: '/booking-success',
//     element: <screens.BookingSuccess />,
//   },
//   {
//     path: '/profile/edit',
//     element: <screens.ProfileEdit />,
//   },
//   {
//     path: '/profile/my-coupons',
//     element: <screens.MyCoupons />,
//   },
//   {
//     path: '/account-created',
//     element: <screens.SignUpAccountCreated />,
//   },
//   {
//     path: '/category-grid',
//     element: <screens.CategoryGrid />,
//   },
//   {
//     path: '/my-booking',
//     element: <screens.ListDetails />,
//   },
//   {
//     path: '/shortlisted',
//     element: <screens.Shortlisted />,
//   },
//   {
//     path: '/dashboard',
//     element: <screens.Dashboard />,
//   },
//   {
//     path: '/leave-a-review',
//     element: <screens.LeaveAReview />,
//   },
//   {
//     path: '/add-a-new-card',
//     element: <screens.AddANewCard />,
//   },
//   {
//     path: ' ',
//     element: <screens.CourseCompletedCertificate />,
//   },
//   {
//     path: '/checkout',
//     element: <screens.Checkout />,
//   },
//   {
//     path: '/filter',
//     element: <screens.Filter />,
//   },
//   {
//     path: '/profile/my-wallet',
//     element: <screens.MyWallet />,
//   },
//   {
//     path: '/course-completed',
//     element: <screens.CourseCompleted />,
//   },
//   {
//     path: '/category-list',
//     element: (
//       <ProtectedRoute>
//         <screens.CategoryList />
//       </ProtectedRoute>
//     ),
//     // element: <screens.CategoryList />,
//   },
//   {
//     path: '/aminity-list',
//     element: <screens.AminitiesList />,
//   },
//   {
//     path: '/payment-failed',
//     element: <screens.PaymentFailed />,
//   },
//   // {
//   //   path: '/tab-navigator',
//   //   element: <TabNavigator />,
//   // },

//   {
//     path: '/home',
//     element: <Home />,
//   },
//   {
//     path: '/serach-result',
//     element: <Home2 />,
//   },
// ]);

// export const StackNavigator: React.FC = () => {
//   return <RouterProvider router={stack}
//     future={{
//       v7_startTransition: true,
//       // v7_relativeSplatPath: true,
//     }}
//   />;
// };



